/* eslint-disable @typescript-eslint/no-explicit-any */
import { NumericFormat, OnValueChange } from 'react-number-format';

import {
  Input,
  Row,
  Select,
  InputProps,
  buildChangeEventLike,
  WithLabelWrapper,
  ChangeEventLike,
} from 'components/Blocks';
import { CircleDollarIcon } from 'components/Icons';

import { cn } from 'styles';
import { CURRENCY_OPTIONS } from 'utils/constants';

export type MonetaryInputProps = {
  children?: never;

  wrapperClassName?: string;

  currencyClassName?: string;
  currency?: string;
  currencyDisabled?: boolean;
  currencyHide?: boolean;
  currencyName?: string;
  onCurrencyChangeDirect?: (value: string) => void;
  onCurrencyChange?: (value: ChangeEventLike) => void;

  value?: string;
  defaultValue?: string;

  onChangeDirect?: (value: string) => void;
} & Omit<InputProps, 'type' | 'value' | 'defaultValue'>;

function MonetaryInputBase({
  wrapperClassName,

  currencyClassName,
  currency,
  currencyDisabled,
  currencyName,
  onCurrencyChange,
  onCurrencyChangeDirect,

  onChange,
  onChangeDirect,

  ...props
}: MonetaryInputProps) {
  // This verification is being done because when an id is not passed in the input,
  // the lib creates one like this: :r1n:
  const id = props.id?.startsWith(':') ? undefined : props.id;

  // default input value returns the formatted value instead
  const handleChange: OnValueChange = ({ value }) => {
    onChange?.(
      buildChangeEventLike({
        id,
        name: props.name,
        value,
      }) as any,
    );

    onChangeDirect?.(value);
  };

  const handleCurrencyChange = (currency: string) => {
    onCurrencyChange?.(
      buildChangeEventLike({
        id,
        name: props.name,
        value: currency,
      }),
    );

    onCurrencyChangeDirect?.(currency);
  };

  const isCurrencyDisabled = currencyDisabled ?? props.disabled;

  return (
    <Row gap="0" className={cn('rounded-lg border focus-within:border-primary', wrapperClassName)}>
      <Select
        containerClassName="shrink-0"
        className={cn(
          'shrink-0 border-none ring-0 [&_svg]:h-4 [&_svg]:w-4',
          isCurrencyDisabled && '[&_svg]:hidden',
          currencyClassName,
        )}
        focusStyle="border"
        isSearchable={false}
        placeholder={<CircleDollarIcon size={14} />}
        options={CURRENCY_OPTIONS}
        value={currency}
        disabled={isCurrencyDisabled}
        name={currencyName}
        onChangeDirect={handleCurrencyChange}
      />

      <NumericFormat
        {...props}
        // getInputRef={ref}
        customInput={Input}
        focusStyle="border"
        className={cn('border-none pl-1', props.className)}
        onValueChange={handleChange}
        valueIsNumericString
        allowNegative={false}
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale
        thousandSeparator
      />
    </Row>
  );
}

export const MonetaryInput = WithLabelWrapper(MonetaryInputBase);
